import { Injectable, inject } from '@angular/core'
import { AccountObject } from '@tradecafe/types/core'
import { DeepReadonly } from '@tradecafe/types/utils'
import { ModalService } from 'src/shared/modal'
import { AddToBuyerGroupsDialogComponent, AddToBuyerGroupsDialogData } from './add-to-buyer-groups-dialog.component'

@Injectable()
export class AddToBuyerGroupsService {
  private readonly modal = inject(ModalService)


  showAddToBuyerGroups(selectedCompanies: DeepReadonly<AccountObject>[]) {
    return this.modal.openDialog<
      AddToBuyerGroupsDialogComponent,
      AddToBuyerGroupsDialogData,
      boolean
    >(
      AddToBuyerGroupsDialogComponent,
      { selectedCompanies },
    ).toPromise()
  }
}
